import { Component, Input, OnInit, inject } from '@angular/core';
import {SharedModalControllerService} from "@shared/services/shared-modal-controller.service";
import {IonicModule} from "@ionic/angular";
import {AsyncPipe} from "@angular/common";
import {TranslatePipe} from "@ngx-translate/core";
import {FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {select, Store} from "@ngrx/store";
import {Observable, of, withLatestFrom} from "rxjs";
import {map} from "rxjs/operators";
import {TeamRegisterState} from "@team/pages/register/store/team-register.state";
import {TeamRegisterActions} from "@team/pages/register/store/team-register.actions-type";
import {TeamRegisterSelectors} from "@team/pages/register/store/team-register.selector-type";
import {TeamLoginRegisterUserFormComponent} from "@team/pages/register/components/register-user-form/team-login-register-user-form.component";
import {IDispatchRegisterGuest} from "@team/pages/register/interfaces/dispatch-register-guest.interface";

@Component({
  selector: 'app-team-register-page',
  templateUrl: './team-register-page.html',
  styleUrls: ['./team-register-page.scss'],
  imports: [
    IonicModule,
    TranslatePipe,
    FormsModule,
    ReactiveFormsModule,
    TeamLoginRegisterUserFormComponent,
    AsyncPipe
],
  standalone: true
})
export class TeamRegisterPage implements OnInit {
  private _sharedModalControllerService = inject(SharedModalControllerService);
  private _store = inject<Store<TeamRegisterState>>(Store);


  @Input() currentEmail: string;

  registerUserShadowForm: FormGroup;
  isSubmitDisabled: boolean;
  isLoading$: Observable<boolean>;
  buttonId: string;

  constructor() {
    this.registerUserShadowForm = new FormGroup({});
    this.isSubmitDisabled = true;
    this.isLoading$ = of(false);
    this.buttonId = "submitRegister"
    this.currentEmail = "";
  }

  ngOnInit() {
    this.isLoading$ = this._store.pipe(select(TeamRegisterSelectors.selectIsLoading));
  }

  /**
   * @name exit
   * @description
   * close the modal
   * @memberof TeamRegisterPage
   */
  exit(): void {
    this._store.dispatch(TeamRegisterActions.initRegistrationGuestDialogClose());
    this._sharedModalControllerService.closeModal();
  }

  /**
   * @name submit
   * @description
   * dispatch the action on submit to complete the invitation
   * @memberof TeamRegisterPage
   */
  submit(): void {
    const password = this.registerUserShadowForm.value.password;
    const dispatchData: IDispatchRegisterGuest = {
      password: password,
      passwordBase64: btoa(password),
      confirmPassword: this.registerUserShadowForm.value.confirmPassword,
      email: this.registerUserShadowForm.value.email
    };

    if (dispatchData.password === dispatchData.confirmPassword) {
      this.dispatchRegisterGuestPinRequest(dispatchData);
    }
  }

  /**
   * @name onFormChange
   * @description
   * handle emit event to update the shadow form
   * @memberof TeamRegisterPage
   * @param form
   */
  onFormChange(form: FormGroup): void {
    this.registerUserShadowForm = form;
  }

  /**
   * @name dispatchRegisterGuestPinRequest
   * @description
   * dispatch the register guest pin request action
   * @memberof TeamRegisterPage
   * @param data
   */
  dispatchRegisterGuestPinRequest(data: IDispatchRegisterGuest): void {
    this._store.dispatch(TeamRegisterActions.registerGuestPinRequest({
      registerGuest: {
        isRetry: false,
        email: data.email,
        passwordBase64: data.passwordBase64
      },
      isLoadingId: this.buttonId
    }))
  }
}
